<template>
  <v-app-bar
    color="black"
    dense
    dark
    min-height="6.5vh"
    max-height="6.5vh"
    flat
    class="header-bar"
  >
    <v-menu bottom left>
      <template v-slot:activator="{ on }">
        <v-btn icon v-on="on">
          <v-icon>mdi-menu</v-icon>
        </v-btn>
      </template>

      <v-list>
        <template v-if="isLoggedIn">
          <v-list-item to="/dashboard" @click.native="clickTrack('dashboard')">
            <v-list-item-title>
              <i class="header-img" style="vertical-align: middle"
                ><img svg-inline alt="1" src="@/assets/svg/dashboard.svg"
              /></i>
              {{ $t('navigation.dashboard') }}
            </v-list-item-title>
          </v-list-item>
          <v-list-item to="/locations" @click.native="clickTrack('locations')">
            <v-list-item-title>
              <v-icon
                class="header-img"
                style="vertical-align: middle"
                color="white"
                size="14"
                >mdi-map-marker</v-icon
              >
              {{ $t('navigation.locations') }}
            </v-list-item-title>
          </v-list-item>
          <v-list-item
            to="/library"
            v-if="showCaseLibrary"
            @click.native="clickTrack('library')"
          >
            <v-list-item-title>
              <i class="header-img" style="vertical-align: middle"
                ><img svg-inline alt="2" src="@/assets/svg/library.svg"
              /></i>
              {{ $t('navigation.caseLibrary') }}
            </v-list-item-title>
          </v-list-item>
          <v-list-item to="/views" v-if="hasMultiView">
            <v-list-item-title>
              <i class="header-img" style="vertical-align: middle"
                ><img svg-inline alt="3" src="@/assets/svg/viewIcon.svg"
              /></i>
              {{ $t('navigation.views') }}
            </v-list-item-title>
          </v-list-item>
          <v-list-item
            to="/search"
            v-if="hasSearchView"
            @click.native="clickTrack('search')"
          >
            <v-list-item-title>
              <v-icon color="white" size="14">mdi-magnify</v-icon>
              {{ $t('navigation.search') }}
            </v-list-item-title>
          </v-list-item>
          <v-list-item
            to="/admin"
            v-if="showAdmin"
            @click.native="clickTrack('admin')"
          >
            <v-list-item-title>
              <i class="header-img" style="vertical-align: middle"
                ><img
                  alt="6"
                  svg-inline
                  class="gear-icon-tweak"
                  src="@/assets/svg/gear.svg"
              /></i>
              {{ $t('navigation.administration') }}
            </v-list-item-title>
          </v-list-item>
        </template>
        <template v-if="!isLoggedIn">
          <v-list-item
            :to="sharedCasesLink"
            @click.native="clickTrack('library')"
          >
            <v-list-item-title>
              <i class="header-img" style="vertical-align: middle"
                ><img svg-inline alt="4" src="@/assets/svg/library.svg"
              /></i>
              {{ $t('navigation.caseLibrary') }}
            </v-list-item-title>
          </v-list-item>
        </template>
      </v-list>
    </v-menu>
    <v-toolbar-title class="toolbar-logo">
      <i
        ><img
          alt="5"
          svg-inline
          src="@/assets/svg/3xLogo.svg"
          class="mobile-customer-logo"
          @click="routeToDashboard"
      /></i>
    </v-toolbar-title>

    <v-spacer></v-spacer>
    <NotificationsIcon />
    <AccountMenu />
  </v-app-bar>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import AccountMenu from './../AccountMenu.vue'
import NotificationsIcon from '../notifications/NotificationsIcon.vue'
import {
  DASHBOARD_NAV_CLICK,
  LOCATIONS_NAV_CLICK,
  LIBRARY_NAV_CLICK,
  ADMIN_NAV_CLICK,
} from '@/constants/mixpanelEvents'

export default defineComponent({
  name: 'CustomerUserMobileNav',
  props: {
    showAdmin: {
      type: Boolean,
      required: true,
    },
    showCaseLibrary: {
      type: Boolean,
      required: true,
    },
    navTabsOptional: {
      type: Boolean,
      required: true,
    },
    hasMultiView: {
      type: Boolean,
      required: true,
    },
    hasSearchView: {
      type: Boolean,
      required: true,
    },
    isLoggedIn: {
      type: Boolean,
      required: true,
    },
    queryString: {
      type: String,
      required: false,
    },
  },
  components: {
    AccountMenu,
    NotificationsIcon,
  },
  computed: {
    sharedCasesLink() {
      return { name: 'SharedCases', query: { h: this.queryString } }
    },
  },
  methods: {
    routeToDashboard() {
      this.$router.push('/dashboard')
      this.$mixpanelUserTrack(DASHBOARD_NAV_CLICK)
    },
    clickTrack(navItem) {
      if (navItem === 'dashboard') {
        this.$mixpanelUserTrack(DASHBOARD_NAV_CLICK)
      } else if (navItem === 'locations') {
        this.$mixpanelUserTrack(LOCATIONS_NAV_CLICK)
      } else if (navItem === 'library') {
        this.$mixpanelUserTrack(LIBRARY_NAV_CLICK)
      } else if (navItem === 'admin') {
        this.$mixpanelUserTrack(ADMIN_NAV_CLICK)
      }
    },
  },
})
</script>
<style lang="scss">
.header-bar {
  .header-img {
    vertical-align: middle;
  }
}
</style>
